/* eslint-disable */
import { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import { getEventsInCourse, getOpenDate } from '@/store/course/actions';
import {
  addUserEvent,
  checkStudyPlan,
  createStudyPlan,
  updateButtonFunc,
  updateStudyPlanDate,
} from '@/store/study-plan/actions';

import { selectCourse as courseSelect } from '@/store/course/selectors';
import { selectStudyPlan as planSelect } from '@/store/study-plan/selectors';
import { selectTopics as topicsSelect } from '@/store/topics/selectors';
import { selectUsers as usersSelect } from '@/store/users/selectors';

import { Alert, Button, Input, Layout, Modal, Spin } from 'antd';
import CalendarModal from '@/pages/CalendarModal/index.jsx';
import EventRow from '@/components/EventRow';
import { InfoCircleFilled } from '@ant-design/icons';

import {
  getWithoutSchedule,
  isCorpCourseWithOrWithoutApprove,
  isCorporateCourseWithoutApprove,
  isExternalCourse,
  isTestCourses,
} from '@shared/utils/topic-utils';

import Utils from '@/Utils';
import { createSelector } from '@reduxjs/toolkit';
import classNames from 'classnames';
import dayjs from 'dayjs';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';

import css from './MaterialsTabs.module.scss';

import {
  APPROVED_BY_USER,
  PLANNED,
  REJECTED_BY_USER,
  SCHEDULED,
  WAITING_BY_USER,
} from '@/constants/study-plan-statuses';

const { Content } = Layout;
const { TextArea } = Input;

// в 6970 удалил APPROVED
const updateStatusTopicWithoutApprove = [APPROVED_BY_USER, PLANNED, REJECTED_BY_USER, WAITING_BY_USER];

class MaterialsTabsEvents extends Component {
  static propTypes = {
    checkStudyPlan: PropTypes.func,
    createStudyPlan: PropTypes.func,
    currentTopicId: PropTypes.number,
    currentUserId: PropTypes.number,
    endedCount: PropTypes.number,
    endedEvents: PropTypes.array,
    eventCount: PropTypes.number,
    events: PropTypes.array,
    getEventsInCourse: PropTypes.func,
    getOpenDate: PropTypes.func,
    isLoading: PropTypes.bool,
    loadMore: PropTypes.bool,
    openDate: PropTypes.string,
    page: PropTypes.number,
    planIsLoading: PropTypes.bool,
    planStatus: PropTypes.bool,
    status: PropTypes.string,
    studyPlanId: PropTypes.object,
    topic: PropTypes.object,
    topicId: PropTypes.number,
    topicStatus: PropTypes.string,
    topicType: PropTypes.number,
    topicTypeName: PropTypes.string,
    updateButtonFunc: PropTypes.func,
    currentUser: PropTypes.object,
    updateStudyPlanDate: PropTypes.func,
    addUserEvent: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.state = {
      isInPlan: {},
      modalVisible: false,
      studyPlanId: props.studyPlanId,
      startEndedLoad: false,
      independent: this.props.topic && this.props.topic.independent,
      selectedEventId: null,
    };
  }

  isOnline = () => Utils.isOnline();

  componentDidMount() {
    if (!this.isOnline()) return;

    this.props.getOpenDate();
    this.props.getEventsInCourse({
      topicId: this.props.topicId,
      isEnded: false,
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.studyPlanId !== nextProps.studyPlanId) {
      this.setState({ studyPlanId: nextProps.studyPlanId });
    }
  }

  handleStudyPlanClick = (planningTopicId, selectedMonths, comment, withoutSchedule) => {
    const userId = this.props.currentUserId;
    const studyPlanId = this.props?.studyPlanId?.id;
    const topicId = this.props.topicId;
    const planDate = dayjs(this.state.data || selectedMonths[0]).format('YYYY-MM-DD');

    const onSuccess = () => {
      if (!this.state.calendarModalVisible) {
        this.setState({ modalVisible: !this.state.modalVisible });
      } else {
        this.setState({ data: dayjs(selectedMonths[0], 'YYYY-MM-DD') });
      }

      if (isCorporateCourseWithoutApprove(this.props.topicType)) {
        this.props.getEventsInCourse({
          topicId: this.props.topicId,
          isEnded: false,
        });
      }

      this.setState({ calendarModalVisible: false });
      this.props.updateButtonFunc();
    };
    const commentStudyPlan = comment || this.state.comment;

    const update35Posibility =
      isCorporateCourseWithoutApprove(this.props.topicType) &&
      updateStatusTopicWithoutApprove.includes(this.props?.studyPlanId.status);

    const updateStudyPlanPosibility = isTestCourses(this.props.topicType) && this.props?.studyPlanId?.id;

    if (updateStudyPlanPosibility) {
      this.props.updateStudyPlanDate(
        studyPlanId,
        planDate,
        commentStudyPlan,
        onSuccess,
        true,
        this.state.selectedEventId
      );
    } else if (update35Posibility) {
      this.props.addUserEvent(this.state.selectedEventId, [this.props?.studyPlanId?.requestId], onSuccess);
    } else {
      this.props.createStudyPlan(
        userId,
        topicId,
        planDate,
        SCHEDULED,
        commentStudyPlan,
        onSuccess,
        false,
        getWithoutSchedule(
          this.props.topicType,
          withoutSchedule || (isCorpCourseWithOrWithoutApprove(this.props.topicType) && this.props.eventCount === 0)
        ),
        undefined,
        this.state?.selectedEventId
      );
    }
  };

  handleStudyPlanModal = event => {
    if (!!event) {
      this.setState(
        {
          data: dayjs(event?.startTime, 'YYYY-MM-DD') || undefined,
          selectedEventId: event?.id || undefined,
        },
        () => {
          if (isCorporateCourseWithoutApprove(this.props.topicType)) {
            this.handleStudyPlanClick();
          } else {
            this.setState({ modalVisible: !this.state.modalVisible });
          }
        }
      );
    }
  };

  handleCalendarModal = params => {
    // toCalendar: bool
    this.setState({
      topicInfo: {
        ...this.props.topic,
        link: this.props.topic.firstLink,
        topicCost: this.props.topic.cost,
        eventCount: this.props.topic.eventCount,
      },
      calendarModalVisible: !this.state.calendarModalVisible,
      toCalendar: params.toCalendar,
    });
  };

  changeComment = event => {
    const text = event.target.value;
    this.setState({ comment: text });
  };

  loadEndedEvents = (params, onButton) => {
    if (onButton) {
      this.setState({ startEndedLoad: true });
    }
    this.props.getEventsInCourse(
      {
        topicId: this.props.topicId,
        size: params.size,
        page: this.props.page,
        isEnded: true,
      },
      res => {
        if (res.length === 0) {
          this.setState({ startEndedLoad: true });
        }
      }
    );
  };

  toCalendar = () => this.handleCalendarModal({ toCalendar: true });

  render() {
    const {
      events,
      endedEvents,
      topicType,
      isLoading,
      loadMore,
      status,
      planIsLoading,
      topicTypeName,
      endedCount,
      openDate,
      t,
    } = this.props;
    const { studyPlanId } = this.state;
    const planStatus = this.props.studyPlanId && this.props.studyPlanId.status;
    const eventDisabled = status === 'DISABLED';

    const EventItems =
      events &&
      events.map(event => (
        <EventRow
          key={event.id}
          event={event}
          eventDisabled={eventDisabled}
          addToPlan={this.handleStudyPlanModal}
          planStatus={planStatus}
          topicType={topicType}
          openDate={this.state.independent ? dayjs().format('YYYY-MM-DD') : openDate}
          topicStatus={this.props.topicStatus}
          currentUser={this.props.currentUser}
        />
      ));

    const EndedEventItems =
      endedEvents &&
      endedEvents.map(endedEvent => (
        <EventRow
          key={`EndedEvent-${endedEvent.id}`}
          topicType={topicType}
          event={endedEvent}
          addToPlan={this.handleStudyPlanModal}
          planStatus={planStatus}
          topicStatus={this.props.topicStatus}
          openDate={this.state.independent ? dayjs().format('YYYY-MM-DD') : openDate}
          eventDisabled={eventDisabled}
          currentUser={this.props.currentUser}
        />
      ));
    const infoString = `${topicTypeName} ${t('addedToPlan')} ${
      !isCorpCourseWithOrWithoutApprove(topicType) && !studyPlanId.withoutSchedule
        ? dayjs(studyPlanId.startDate).format('DD MMMM YYYY')
        : dayjs(studyPlanId.startDate).format('MMMM YYYY')
    }.`;

    const notDeactivatedStatus = status !== t('deactivated');

    return (
      <Content className={css.MaterialsTabsEventsTable}>
        {notDeactivatedStatus ? (
          !isEmpty(studyPlanId) ? (
            <div className={css.MaterialsTabsEventsTable__infoText}>
              {infoString} <a href='/Planning'>{t('goToPlan')}</a>
            </div>
          ) : events && events.length === 0 ? (
            <div className={css.MaterialsTabsEventsTable__infoText}>
              {isExternalCourse(topicType) ? (
                <div>
                  {t('participation')}
                  <a onClick={this.toCalendar}>{t('leaveRequest')}</a>
                </div>
              ) : (
                <div>
                  {t('leaveCorporateRequest')}
                  <a onClick={this.toCalendar}>{t('chooseMonth')}</a>
                </div>
              )}
            </div>
          ) : (
            <div className={css.MaterialsTabsEventsTable__infoText}>
              {isCorpCourseWithOrWithoutApprove(topicType) ? (
                <div>
                  {t('dontFindDate')}
                  <a onClick={this.toCalendar}>{t('chooseMonth')}</a>
                </div>
              ) : (
                <div>
                  {t('leave')}
                  <a onClick={this.toCalendar}>{t('leaveRequest')}</a>
                </div>
              )}
            </div>
          )
        ) : (
          <div className={css.MaterialsTabsEventsTable__infoText}>{t('unActive')}</div>
        )}
        <Spin spinning={isLoading}>
          {EventItems}
          {this.state.startEndedLoad && EndedEventItems}
          <div className={css.MaterialsTabsEventsTable__loadBtnBox}>
            {endedCount > 0 && (loadMore || !this.state.startEndedLoad) && !isLoading && (
              <Button
                disabled={isLoading}
                onClick={() => this.loadEndedEvents({ size: 10 }, true)}
                type='primary'
                size='large'
              >
                {endedEvents && (endedEvents.length < 3 ? t('showPast') : t('showMore'))}
              </Button>
            )}
          </div>
        </Spin>
        <CalendarModal
          open={this.state.calendarModalVisible}
          onOk={this.handleStudyPlanClick}
          onCancel={this.handleCalendarModal}
          okText={t('addToPlan')}
          title={t('month')}
          planningTopicId={this.props.currentTopicId}
          topicInfo={this.state.topicInfo}
          eventTypeId={this.props.topicType}
          toCalendar={this.state.toCalendar}
          hasEvents={this.state.topicInfo && this.state.topicInfo.eventCount !== 0}
          selectMonthEvents={isCorpCourseWithOrWithoutApprove(this.props.topicType) || this.props.topicType === 20}
        />

        <Modal open={this.state.modalVisible} width={800} footer={null} onCancel={this.handleStudyPlanModal}>
          <div className={css['Description']}>
            <div className={css['Description-title']}>{t('confirmation')}</div>
            <Alert
              className={css['Description-info']}
              message={t('sendDescription')}
              showIcon
              type='info'
              icon={<InfoCircleFilled className={css['Description-info-icon']} />}
              closable
            />
            <div className={css['Comment-block']}>
              <div className={css['Comment-block-label']}>{t('сommentary')}</div>
              <TextArea
                className={css.Comment}
                placeholder={t('comment')}
                rows={3}
                style={{ resize: 'none' }}
                onChange={this.changeComment}
                value={this.state.comment}
                maxLength={500}
              />
            </div>
          </div>
          <div className={css['Button-box']}>
            <Button onClick={this.handleStudyPlanModal}>{t('cancel')}</Button>
            <Button onClick={this.handleStudyPlanClick} type='primary'>
              {t('sendRequest')}
            </Button>
          </div>
        </Modal>
      </Content>
    );
  }
}

const mapStateToProps = createSelector(
  [courseSelect, topicsSelect, usersSelect, planSelect],
  (course, topics, users, studyPlan) => ({
    events: course.events,
    endedEvents: (course.endedEvents && course.endedEvents.elements) || [],
    endedCount: topics.topic && topics.topic.endedCount,
    loadMore: course.endedEvents && course.endedEvents.loadMore,
    page: course.endedEvents && course.endedEvents.page,
    isLoading: course.isLoading,
    openDate: (course.openDate && course.openDate.openDate) || null,
    planIsLoading: studyPlan.isLoading,
    topicId: topics.topic && topics.topic.id,
    topicDate: topics.topic && topics.topic.startDate,
    currentUserId: users.currentUser && users.currentUser.id,
    topicStatus: topics.topic && topics.topic.status,
    studyPlanId: studyPlan.studyPlanId.length !== 0 ? studyPlan.studyPlanId[0] : {},
  })
);

const mapActionsToProps = {
  getEventsInCourse,
  getOpenDate,
  updateButtonFunc,
  createStudyPlan,
  checkStudyPlan,
  updateStudyPlanDate,
  addUserEvent,
};

export default connect(mapStateToProps, mapActionsToProps)(withTranslation('materialsTabsEvents')(MaterialsTabsEvents));
